<div fxLayout="column" class="navList">
  <small class="debug">{{me}}</small>
  <div fxLayout="row" class="input-group d-flex-center">
    <mat-form-field style="width: 80%; margin-right: 10px;">
      <mat-label>{{'placeholder.search' | transloco}}</mat-label>
      <input matInput type="text"
        (keyup)="search()"
        name="SearchDualList"
        class="form-control"
        [(ngModel)]="filter"
        autocomplete="off"/>
        <a matSuffix aria-label="Clear" (click)="filter=''">
          <mat-icon>close</mat-icon>
        </a>
      </mat-form-field>
      <button class="mini-button" mat-icon-button (click)="expandAll()">
        <mat-icon>unfold_more</mat-icon>
      </button>
      <button class="mini-button" mat-icon-button (click)="collapsAll()">
        <mat-icon>unfold_less</mat-icon>
      </button>
    </div>
    <mat-tree #matTree class="tree-wrapper" [dataSource]="dataSource" [treeControl]="treeControl" [ngClass]="{'d-none': filter.length > 1}">
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
        <li class="node-item" [ngClass]="{'active': activeNode?.blockId == node.blockId}" (click)="clickNode(node)">
          <fa-icon [icon]="node.icon"></fa-icon>
          <span>{{node.name}}</span>
        </li>
      </mat-tree-node>
      <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
        <li>
          <div class="mat-tree-node parent-node-item" [ngClass]="{'active': activeNode?.sceneId == node.sceneId}">
            <button mat-icon-button matTreeNodeToggle class="mini-button" (click)="clickNode(node)">
              <fa-icon [icon]="treeControl.isExpanded(node) ? faFolderOpen : faFolder"></fa-icon>
            </button>
            <span matTreeNodeToggle (click)="clickNode(node)">{{node.name}}</span>
          </div>
          <ul [hidden]="!treeControl.isExpanded(node)">
            <ng-container matTreeNodeOutlet></ng-container>
          </ul>
        </li>
      </mat-nested-tree-node>
    </mat-tree>
    @if (filter.length > 1) {
      <div>
        @for (node of searchedEvents; track node) {
          <div>
            <div class="node-item mat-tree-node" [ngClass]="{'active': activeNode?.blockId == node.blockId}" (click)="clickNode(node)">
              <fa-icon [icon]="node.icon"></fa-icon>
              <span>{{node.name}}</span>
            </div>
          </div>
        }
      </div>
    }
  </div>
